<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <p
                        style="position: absolute; top: 10%; left: 8%;font-family: Lato; text-transform: unset !important; font-style: normal; font-weight: bold; color: #059BCA; font-size: 18px; font-weight: 900;">
                        ¿Hay espuma en la deposición?</p>
                    <v-row>
                        <v-col cols="6">
                            <input type="radio" id="yes" value="Yes"
                                style="position: absolute; height: 25px; width: 25px; top:23%; left: 8%;" v-model="foam">
                            <label for="yes"
                                style="position: absolute; top:23.5%; left: 19%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">Si</label>
                        </v-col>
                        <v-col cols="6">
                            <v-btn elevation="12" v-on:click="click(0)"
                                style="position: absolute; top: 20%; left: 65%; width: 25%; padding-top: 6%; padding-bottom: 6%;
                                                                                        font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 10px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                                <b>Ver ejemplo</b>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <input type="radio" id="no" value="No"
                                style="position: absolute; height: 25px; width: 25px; top:37.5%; left: 8%;" v-model="foam">
                            <label for="no"
                                style="position: absolute; top:38%; left: 19%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">No</label>
                        </v-col>
                        <v-col cols="6">
                            <v-btn elevation="12" v-on:click="click(1)"
                                style="position: absolute; top: 35%; left: 65%; width: 25%; padding-top: 6%; padding-bottom: 6%;
                                                                                        font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 10px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                                <b>Ver ejemplo</b>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <p
                        style="position: absolute; top: 55%; left: 8%; font-family: Lato; text-transform: unset !important; font-style: normal; font-weight: bold; color: #059BCA; font-size: 18px; font-weight: 900;">
                        ¿Qué medicamento ha ingerido?</p>
                    <v-row>
                        <v-col cols="6">
                            <input type="radio" id="citrafleet" value="Citrafleet"
                                style="position: absolute; height: 25px; width: 25px; top:67%; left: 8%; background: #3F616C;"
                                v-model="medicine">
                            <label for="citrafleet"
                                style="position: absolute; top:67.5%; left: 19%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">Citrafleet</label>
                        </v-col>
                        <v-col cols="6">
                            <input type="radio" id="pleinvue" value="Pleinvue"
                                style="position: absolute; height: 25px; width: 25px; top:67%; left: 50%;"
                                v-model="medicine">
                            <label for="pleinvue"
                                style="position: absolute; top:67.5%; left: 60%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">Pleinvue</label>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <input type="radio" id="moviprep" value="Moviprep"
                                style="position: absolute; height: 25px; width: 25px; top:80%; left: 8%;"
                                v-model="medicine">
                            <label for="moviprep"
                                style="position: absolute; top:80.5%; left: 19%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">Moviprep</label>
                        </v-col>
                        <v-col cols="6">
                            <input type="radio" id="casenglicol" value="Casenglicol"
                                style="position: absolute; height: 25px; width: 25px; top:80%; left: 50%;"
                                v-model="medicine">
                            <label for="casenglicol"
                                style="position: absolute; top:80.5%; left: 60%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 17px; font-weight: 400;">Casenglicol</label>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(-1)"
                        style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Ver Tratamiento</b>
                    </v-btn>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>

import CardNav from './CardNav.vue';
import { nextScreen, nextScreenWithParams, nextScreenWithMoreParams } from '../router/utils.js';

export default {
    name: 'ConfigTreatment',
    components: {
        CardNav
    },
    data() {
        return {
            //heightFirstCard: 0,
            //heightSecondCard: 0,
            foam: null,
            medicine: null
        }
    },
    computed: {
        /*currentHeightFirstCard: {
            get: function () {
                return this.heightFirstCard;
            },
            set: function (newValue) {
                this.heightFirstCard = newValue;
            }
        },
        currentHeightSecondCard: {
            get: function () {
                return this.heightSecondCard;
            },
            set: function (newValue) {
                this.heightSecondCard = newValue;
            }
        },*/
    },
    methods: {
        /*matchHeight() {
            if (screen.height <= 700) {
                this.currentHeightFirstCard = 60;
                this.currentHeightSecondCard = 25;
            } else if (screen.height > 701 && screen.height <= 800) {
                this.currentHeightFirstCard = 64;
                this.currentHeightSecondCard = 22;
            } else if (screen.height > 801 && screen.height <= 1400) {
                this.currentHeightFirstCard = 67;
                this.currentHeightSecondCard = 20;
            }
        },*/
        click(number) {
            switch (number) {
                case -1:
                    nextScreenWithMoreParams(this.$router, 'Instructions', this.foam, this.medicine);
                    break;
                case 0:
                    nextScreenWithParams(this.$router, 'Deposition', true);
                    break;
                case 1:
                    nextScreenWithParams(this.$router, 'Deposition', false);
                    break;
            }
        },
    },
    /*mounted() {
        this.matchHeight();
    }*/
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ConfigTreatment.vue